import leaf from "../../../../assets/img/product/leaf 1.svg"
import chart from "../../../../assets/img/product/trending-up.svg"
import clock from "../../../../assets/img/product/clock.svg"
import money from "../../../../assets/img/product/rupiah.svg"
import toAgresive from "../../../../assets/img/product/lightning-bolt 1.svg"
import moderate from "../../../../assets/img/product/air-element 1.svg"
import fire from "../../../../assets/img/product/fire-element.svg"

export default function CardDaftarPinjaman({type, title, number, amount, percentage, tenor, progress, sisaDana, sisaWaktu}){
    return (
        <div className="card-pinjaman">
            {type === 'konservatif'
                ? <div className="tag konservatif"><img src={leaf} alt='leaf'/>Konservatif</div>
                : type === 'moderat'
                    ? <div className="tag moderat"><img src={moderate} alt='leaf'/>Moderat</div>
                    : type === 'agresif'
                        ? <div className="tag agresif"><img src={fire} alt='leaf'/>Agresif</div>
                        : <div className="tag sangat-agresif"><img src={toAgresive} alt='leaf'/>Sangat Agresif</div>
            }
            <div className="title">{title}</div>
            <div className="subtitle">{number}</div>
            <div className="amount"><img src={money} alt='leaf'/>Rp {amount}</div>
            <div className="details">
                <div className="left">
                    <p className="flex gap-1"><img src={chart} alt="trending-up"/>Bunga p.a</p>
                    <p><b>{percentage}% (EFF)</b></p>
                </div>
                <div className="right">
                    <p className="flex gap-1"><img src={clock} alt="clock"/>Tenor</p>
                    <p><b>{tenor} bulan</b></p>
                </div>
            </div>
            <hr/>
            <div className="bar">
                <div className="progress-bar">
                    <div className="progress" style={{width: `${progress}%`}}/>
                </div>
                <span>{progress}%</span>
            </div>
            <div className="info">
                <p>Sisa dana yang dibutuhkan</p>
                <p className='text-right'><b>Rp. {sisaDana}</b></p>
            </div>
            <div className="info">
                <p>Sisa waktu</p>
                <p className='text-right'><b>{sisaWaktu} hari</b></p>
            </div>
        </div>
    );
}